//import "./wdyr";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
// @ts-ignore
import en from "dayjs/locale/en";
import { registerComponents } from "./componentRegistry";
import "./styles/style_vendor.less";
import "./styles/style.less";
import { createInitialHashScroller } from "~/common/createInitialHashScroller";
import { bindLmsLinkListener } from "~/LMS/LmsLinkListener";
import { startZoovuTracking } from "~/feature/Analytics/Zoovu/zoovuTracking";
import "./feature/Analytics";

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.locale({ ...en, weekStart: 1 });

// Based on the sourcecode of react-google-recaptcha/src/recaptcha-wrapper.js we can set a dynamic configuration to use recaptcha.net instead of google
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).recaptchaOptions = {
  useRecaptchaNet: true,
};

registerComponents();

window.addEventListener("load", () => {
  // page is hidden until react loads
  Array.from(document.querySelectorAll(".js__hidden-until-react")).forEach((el) => el.classList.add("react-loaded"));

  if (window.SCHA.config.isZoovuTrackingEnabled) {
    startZoovuTracking();
  }
});

createInitialHashScroller();

bindLmsLinkListener();
